import * as React from "react";
import styled, { StyledComponentClass } from "styled-components";

import { Palette, Metrics } from "../../vars";

const { Padding, FontSizes } = Metrics;

const OverlayCollapsibleToggle = ({
  children,
  className,
  icon,
  onClick,
  open
}) => (
  <div className={className} onClick={onClick}>
    <i className="md-icon">{icon}</i>
    {children}
    <i className="md-icon expand">{open ? "remove" : "add"}</i>
  </div>
);

export default styled(OverlayCollapsibleToggle)`
  display: flex;
  align-items: center;
  position: relative;
  color: ${Palette.Rebrand.Colours.P6};
  height: 64px;
  line-height: 64px;
  padding: 0 ${Padding.OVERLAY_MENU_TOGGLE_RIGHT}px 0
    ${Padding.OVERLAY_MENU_TOGGLE_LEFT}px;
  font-size: ${FontSizes.OVERLAY_MENU_TOGGLE_TEXT}px;
  border-bottom: 1px solid ${Palette.Rebrand.Colours.G2};

  .md-icon {
    color: ${Palette.Rebrand.Colours.P4};
    margin-right: 12px;
  }

  .expand {
    color: ${Palette.Rebrand.Colours.P1};
    display: inline-block;
    position: absolute;
    height: 64px;
    line-height: 64px;
    right: 0;
    padding: 0 24px;
    border-left: 1px solid ${Palette.Rebrand.Colours.G2};
    margin-right: 5px;
  }
` as StyledComponentClass<any, any>;
